type RuntimeEnv = {
  VUE_APP_BACKEND: string
  VUE_APP_BACKEND_BASE: string
  VUE_APP_SOCKET_URL: string
  VUE_APP_SERVER: string
  VUE_APP_STREAM_URL: string
  VUE_APP_MAIN: string
  VUE_APP_REPAIRS: string
  VUE_APP_PROJECTS: string
  VUE_APP_CONTROLS: string
  VUE_APP_VIDEO: string
  VUE_APP_USERS: string
  VUE_APP_RITM: string
}

export const env = (window as any).__ENV__ as RuntimeEnv
